module.exports = __webpack_public_path__ + "site/img/icon-pudu.42130834.svg";